import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useEventLogger } from '../useEventLogger.mjs';
import useReferenceSafeObject from '../utils/useReferenceSafeObject.mjs';
import useOnce from '../utils/useOnce.mjs';

function ImpressionV2(props) {
  return props.fireInView ? /* @__PURE__ */ jsx(ImpressionWithInView, { ...props }) : /* @__PURE__ */ jsx(ImpressionRaw, { ...props });
}
function ImpressionRaw(props) {
  const {
    eventProperties: eventPropertiesRaw,
    action,
    children,
    once = true
  } = props;
  const eventProperties = useReferenceSafeObject(eventPropertiesRaw);
  const { impression: impressionRaw } = useEventLogger();
  const impressionOnce = useOnce(impressionRaw);
  const impression = once ? impressionOnce : impressionRaw;
  useEffect(() => {
    impression(action, eventProperties);
  }, [impression, action, eventProperties]);
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function ImpressionWithInView(props) {
  const {
    eventProperties: eventPropertiesRaw,
    action,
    children,
    once = true
  } = props;
  const eventProperties = useReferenceSafeObject(eventPropertiesRaw);
  const { ref: observerRef, inView } = useInView();
  const { impression: impressionRaw } = useEventLogger();
  const impressionOnce = useOnce(impressionRaw);
  const impression = once ? impressionOnce : impressionRaw;
  useEffect(() => {
    if (inView) {
      impression(action, eventProperties);
    }
  }, [impression, action, eventProperties, inView]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(IntersectionObserverTarget, { "aria-hidden": "true", ref: observerRef }),
    children
  ] });
}
const IntersectionObserverTarget = "div";

export { ImpressionV2 as default };
//# sourceMappingURL=Impression.mjs.map
